import type { RouteObject } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Home from '@/pages/home/page';
import Category from '@/pages/category/page';
import MovieDetail from '@/pages/detail/page';
import News from '@/pages/news/page';
import NewsDetail from '@/pages/news/detail/page';
import Search from '@/pages/search/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'category', element: <Category /> },
      { path: 'detail/:id', element: <MovieDetail /> },
      { path: 'news', element: <News /> },
      { path: 'news/:id', element: <NewsDetail /> },
      { path: 'search', element: <Search /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;